/**
 * ProgressSteps Component
 * 3-step progress indicator for search stages
 */

import React, { useEffect, useState } from 'react';
import './loading.css';

const STEPS = [
  { id: 'searching', label: 'Buscando' },
  { id: 'analyzing', label: 'Analizando' },
  { id: 'preparing', label: 'Preparando' },
];

const STEP_DURATION = 2000; // 2 seconds per step

export const ProgressSteps: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % STEPS.length);
    }, STEP_DURATION);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ai360-progress-steps">
      {STEPS.map((step, index) => (
        <div
          key={step.id}
          className={`ai360-progress-step ${
            index === currentStep ? 'ai360-progress-step--active' : ''
          } ${index < currentStep ? 'ai360-progress-step--completed' : ''}`}
        >
          <div className="ai360-progress-step-dot" />
          <span className="ai360-progress-step-label">{step.label}</span>
          {index < STEPS.length - 1 && (
            <div className="ai360-progress-step-line" />
          )}
        </div>
      ))}
    </div>
  );
};
